// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header_container__dKQex {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
}

.Header_container__dKQex .Header_logo__tFOZh {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.Header_container__dKQex .Header_headerLogo__bqkbi {
  margin-left: 30px;
  margin-top: 20px;
  max-width: 20%;
  max-height: 90%;
  object-fit: initial;
}

.Header_container__dKQex .Header_lgSelected__\\+Rdum {
  border-bottom: 3px solid rgba(0, 0, 0, 0.239);
}

.Header_container__dKQex .Header_flags__R60cW {
  display: flex;
  justify-content: center;
  align-items: center;
}

.Header_container__dKQex .Header_flags__R60cW .Header_flagIcon__zr2DX {
  transition: 0.3s;
  width: 2.5rem;
  margin-left: 20px;
  cursor: pointer;
}

.Header_container__dKQex .Header_flags__R60cW .Header_flagIcon__zr2DX:hover {
  transition: 0.3s;
  scale: 1.09;
}
`, "",{"version":3,"sources":["webpack://./src/components/Header/index.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb","sourcesContent":[".container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  width: 100%;\n}\n\n.container .logo {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.container .headerLogo {\n  margin-left: 30px;\n  margin-top: 20px;\n  max-width: 20%;\n  max-height: 90%;\n  object-fit: initial;\n}\n\n.container .lgSelected {\n  border-bottom: 3px solid rgba(0, 0, 0, 0.239);\n}\n\n.container .flags {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .flags .flagIcon {\n  transition: 0.3s;\n  width: 2.5rem;\n  margin-left: 20px;\n  cursor: pointer;\n}\n\n.container .flags .flagIcon:hover {\n  transition: 0.3s;\n  scale: 1.09;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Header_container__dKQex`,
	"logo": `Header_logo__tFOZh`,
	"headerLogo": `Header_headerLogo__bqkbi`,
	"lgSelected": `Header_lgSelected__+Rdum`,
	"flags": `Header_flags__R60cW`,
	"flagIcon": `Header_flagIcon__zr2DX`
};
export default ___CSS_LOADER_EXPORT___;
